import React from 'react';
import { Outlet } from 'react-router-dom';

const MessagesInboxWrapper = () => <Outlet />;

export default MessagesInboxWrapper;
